module.exports = __webpack_public_path__ + "images/kingslayer-baef96472c3f0159cfc8d41a791b15cc.png";